const REPORT_ERROR = 'REPORT_ERROR';

export { REPORT_ERROR };
